import { render, staticRenderFns } from "./2_1_listContainer.vue?vue&type=template&id=67d8eeaa&scoped=true&"
import script from "./2_1_listContainer.vue?vue&type=script&lang=js&"
export * from "./2_1_listContainer.vue?vue&type=script&lang=js&"
import style1 from "./2_1_listContainer.vue?vue&type=style&index=1&id=67d8eeaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d8eeaa",
  null
  
)

export default component.exports